import moment from 'moment-timezone';

const format = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(.\d+)?$/

function pad(num, size) {
    var s = "000" + num;
    return s.substr(s.length-size);
}

export default class LocalDateTime{



    constructor(year, month, day, hh, mm, ss) {

        /** @type {string} format: 2021-01-29T12:10:10.0038644*/
        this.value = null;

        if(year !== undefined && month !== undefined && day !== undefined &&
            hh !== undefined && mm !== undefined && ss !== undefined){
            this.set(year, month, day, hh, mm, ss);
        }
    }

    fromMoment(momentDate){
        this.set(momentDate.year(), momentDate.month() + 1, momentDate.date(), momentDate.hour(), momentDate.minutes(), momentDate.seconds() +
            (momentDate.milliseconds() / 1000));
    }

    _getPos(start, end){
        if(this.value === null){
            return null;
        }
        if(!this.value.match(format)){
            return null;
        }
        return Number(this.value.substring(start,end));

    }
    getYear(){
        return this._getPos(0, 4);
    }

    getMonth(){
        return this._getPos(5, 7);
    }

    getDay(){
        return this._getPos(8, 10);
    }

    getHours(){
        return this._getPos(11, 13);
    }

    getMinutes(){
        return this._getPos(14, 16);
    }

    getSeconds(){
        return this._getPos(17, this.value.length);
    }

    toJSON(){
        return this.value;
    }

    asMoment(){
        return moment(this.value);
    }

    set(year, month, day, hh, mm, ss){
        if(ss >= 60){
            ss = 59.9999;
        } else if(ss < 0){
            ss = 0;
        }
        let formattedSeconds = "" + ss;
        if(ss < 10){
            formattedSeconds = "0" + formattedSeconds;
        }

        this.value =  pad(year, 4) + "-" + pad(month, 2) + "-" + pad(day, 2) + "T" + pad(hh, 2) + ":" + pad(mm, 2) + ":" + formattedSeconds;
    }

    toString(format){
        if(this.value){
            return moment(this.value).format(format);
        }
        else{
            return '';
        }
    }
}